export default __webpack_public_path__ + "static/media/dashboard_right_banner.7a42d43a.png";